import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../services/utility-service';
import { ServicerTransferSummaryList } from '../../../model/models';
import {ApiService} from '../../../services/api.service';
import {Title} from '@angular/platform-browser';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-servicer-transfers-results',
  templateUrl: './servicer-transfers-results.component.html',
  styleUrls: ['./servicer-transfers-results.component.scss']
})
export class ServicerTransfersResultsComponent implements OnInit {

  servicerTransferSummaryList: ServicerTransferSummaryList;
  deleteServiceTransferList: ServicerTransferSummaryList = new ServicerTransferSummaryList();
  approvedServiceTransferList: ServicerTransferSummaryList = new ServicerTransferSummaryList();
  cols: any[];
  printCols: any[];
  displayCols: any[];
  excelCols: any[];
  containsError = false;
  errorMsg: string;
  noTranSel: string;
  internalUpdateRoleFlag: string;
  externalUpdateRoleFlag: string;
  isAdminrole: string;
  title = 'List of Servicer Transfers';

    @ViewChildren('deleteCheckbox')
      deleteCheckboxes: QueryList<ElementRef>;

  @ViewChildren('approveCheckbox')
    approvedCheckboxes: QueryList<ElementRef>;

  deleteEnableCheckboxFlag = false;
  approveEnableCheckboxFlag = false;
  pageView: any[];
  selectedPageView: string[];
  exportFilename = 'ServicerTransferQueryList';


  constructor(private activeRouter: ActivatedRoute, private router: Router,
              private apiService: ApiService, private utilService: UtilityService,
              private titleService: Title, private cdr: ChangeDetectorRef) {

    this.pageView = [];
    this.pageView.push({label: 'Printable View', value: 'printView'});
    this.pageView.push({label: 'Download To Excel', value: 'downloadtoExcel'});

    this.selectedPageView = ['printView'];
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');

    this.externalUpdateRoleFlag = sessionStorage.getItem('isRMExternal_Servicing_Update');

    this.internalUpdateRoleFlag = sessionStorage.getItem('isRMInternal_Update');
    this.isAdminrole = sessionStorage.getItem('isAdmin');
    this.isDeleteEnabledOrNot();
    this.isApproveEnabledOrNot();


    this.cols = [
      {field: 'deleted', header: 'Delete ?'},
      {field: 'approved', header: 'Approve ?'},
      {field: 'servicerNumberFrom', header: 'Old Servicer Number'},
      {field: 'servicerNumberTo', header: 'New Servicer Number'},
      /* {field: 'effectiveDate', header: 'Effective Date'},
      {field: 'servTransferStatus', header: 'Status'},
      {field: 'creationDate', header: 'Receipt Date'},*/
      {field: 'effectiveDateConverted', header: 'Effective Date'},
      {field: 'servTransferStatusConverted', header: 'Status'},
      {field: 'creationDateConverted', header: 'Receipt Date'},
      {field: 'portfolioIndicator', header: 'Portfolio Indicator'},
      {field: 'originalCount', header: 'Original Loan Count'},
      {field: 'processedCount', header: 'Processed Loan Count'},
      {field: 'deletedCount', header: 'Deleted Loan Count'}

    ];

    this.excelCols = [
      {field: 'servicerNumberFrom', header: 'Old Servicer Number'},
      {field: 'servicerNumberTo', header: 'New Servicer Number'},
      /* {field: 'effectiveDate', header: 'Effective Date'},
       {field: 'servTransferStatus', header: 'Status'},
       {field: 'creationDate', header: 'Receipt Date'},*/
      {field: 'effectiveDateConverted', header: 'Effective Date'},
      {field: 'servTransferStatusConverted', header: 'Status'},
      {field: 'creationDateConverted', header: 'Receipt Date'},
      {field: 'portfolioIndicator', header: 'Portfolio Indicator'},
      {field: 'originalCount', header: 'Original Loan Count'},
      {field: 'processedCount', header: 'Processed Loan Count'},
      {field: 'deletedCount', header: 'Deleted Loan Count'}

    ];

    this.displayResults();
    this.displayCols = this.displayColumns();
  }

  displayColumns() {

    return this.cols.filter(col =>{
      if (!this.deleteEnableCheckboxFlag)
      {
        return col.field !== 'deleted';
      }
      return true;
    }).filter(col => {
      if (!this.approveEnableCheckboxFlag)
      {
        return col.field !== 'approved';
      }
      return true;
    }).map(col => col);

    /* if (!this.deleteEnableCheckboxFlag)
    {

      filterCols= this.cols.filter(col => {
        return col.field != 'deleted';
      }).map(col => col);
    }
    if (!this.approveEnableCheckboxFlag)
    {
      return this.cols.filter(col => {
        return col.field != 'approved';
      }).map(col => col);
    }

      return this.cols;*/


  }

  isDeleteEnabledOrNot() {
    if (this.externalUpdateRoleFlag === 'true' || this.isAdminrole === 'true'
      || this.internalUpdateRoleFlag === 'true')
    {
      this.deleteEnableCheckboxFlag = true;
    }


  }



  isApproveEnabledOrNot() {
    if (this.isAdminrole === 'true'
      || this.internalUpdateRoleFlag === 'true')
    {
      this.approveEnableCheckboxFlag = true;
    }


  }
  displayResults(): void {
    let data;
    this.activeRouter.queryParams.subscribe(params => {
      data = JSON.parse(atob(params.query));
    });

    /** Call updateUIValue method to update key to Label values */
    this.servicerTransferSummaryList = this.convertValueToLabel(data);
    this.cdr.detectChanges();
  }

  /** convertValueToLabelAndDate method implemented to update key to Label values */
  convertValueToLabel(entity: ServicerTransferSummaryList): any {
    const utilService = new UtilityService();

    entity.forEach(function(part, index, array) {
      /** Convert convertMillisecToDate */
      if (array[index].creationDate != null) {
        array[index].creationDate.date = utilService.convertMillisecToDate(array[index].creationDate.date);
        array[index].creationDateConverted = utilService.convertMillisecToDate(array[index].creationDate.date);
      }

      if (array[index].effectiveDate != null) {
        array[index].effectiveDate.date = utilService.convertMillisecToDate(array[index].effectiveDate.date);
        array[index].effectiveDateConverted = utilService.convertMillisecToDate(array[index].effectiveDate.date);
      }

      /** Get the label value from utilService */
      utilService.transactionStatusType.forEach(function(part1, index1, array1) {
        // servTransferStatus.code comes from the API as a number, lookup values are strings.
        if (array1[index1].value === String(array[index].servTransferStatus.code)) {
          array[index].servTransferStatus.code = array1[index1].label;
          array[index].servTransferStatusConverted = array1[index1].label;
        }
      });

      utilService.portfolioTypeCode.forEach(function(part1, index1, array1) {
        // Compare as strings: portfolioIndicator comes from the API as a number (e.g. 4),
        // while the lookup values here are strings. Strict === without casting silently
        // fails to match, so cast both sides to string before comparing.
        const portfolioIndicatorStr = String(array[index].portfolioIndicator);
        if (portfolioIndicatorStr === '0' || portfolioIndicatorStr === '4') {
          array[index].portfolioIndicator = 'Partial';
        } else if (array1[index1].value === portfolioIndicatorStr) {
          array[index].portfolioIndicator = array1[index1].label;
        }
      });

    });

    return entity;
  }

  selectAll()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      if (!(<any>deleteCheckbox).disabled) {
        (<any>deleteCheckbox).checked = true;
      }
    });


    this.approvedCheckboxes.forEach(approveCheckbox=>{
      if (!(<any>approveCheckbox).disabled) {
        (<any>approveCheckbox).checked = true;
      }
    });


  }


  unSelectAll()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      (<any>deleteCheckbox).checked = false;
    });


    this.approvedCheckboxes.forEach(approveCheckbox => {
      (<any> approveCheckbox).checked = false;
    });


  }

  approveTransfer() {

    this.approvedCheckboxes.forEach(approveCheckbox=>{
      if ((<any>approveCheckbox).checked)
      {
        this.approvedServiceTransferList.push((<any>approveCheckbox).value);
      }


    });

    if (this.approvedServiceTransferList.length > 0)
    {
      this.apiService.saveApprovedDeletedList(this.approvedServiceTransferList);
      this.router.navigate(['/confirmApprove'], {
        queryParams: {
          flag: 'approve',
          query: btoa(JSON.stringify(this.servicerTransferSummaryList))
        }
      });
    }
    else {
      this.noTranSel = 'No Transactions Selected';
    }


  }

  deleteTransfer() {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      if ((<any>deleteCheckbox).checked)
      {
        this.deleteServiceTransferList.push((<any>deleteCheckbox).value);
      }
    });

    if (this.deleteServiceTransferList.length > 0) {
      this.apiService.saveApprovedDeletedList(this.deleteServiceTransferList);
      this.router.navigate(['/confirmDelete'], {
        queryParams: {
          flag: 'delete',
          query: btoa(JSON.stringify(this.servicerTransferSummaryList))
        }
      });
    } else {
      this.noTranSel = 'No Transactions Selected';
    }
  }

  showLoanDetails(serviceTransferData) {
    if (serviceTransferData.portfolioIndicator === 'Partial') {

      this.apiService.setServiceTransferForPartial(serviceTransferData);
      /** Routing to result page when there are matching records. passing list of matching keys to get results */
      this.router.navigate(['partialServiceTransfer'], {
        queryParams: {query: btoa(JSON.stringify(this.servicerTransferSummaryList))}
      });
    }
  }

  onCancel() {
    this.router.navigate(['queryServicerTransfers']);
  }

  public pageViewAction(event: any) {
    event.columns = this.excelCols;
    if (this.selectedPageView.toString() === 'downloadtoExcel') {
      event.exportCSV();
    }
    if (this.selectedPageView.toString() === 'printView')
    {
      const printDetailsMap = new Map();
      printDetailsMap.set('title', 'List Of Servicer Transfers');
      printDetailsMap.set('columns', this.excelCols);
      printDetailsMap.set('data', this.servicerTransferSummaryList);

      this.utilService.printViewData(printDetailsMap);
      this.router.navigate(['print']);
    }

    document.getElementById('cdx-ui-patterns-header-navbar-collapse').style.display = 'inline';
    event.columns = this.displayCols;
  }
}
